




























import DialogButton from "./DialogButton";
import Component from "vue-class-component";
import { Mixins, Prop } from "vue-property-decorator";
import TooltipButton from "@/general/component/tooltip-button/TooltipButton.vue";

@Component({
  components: { TooltipButton }
})
export default class ButtonWithDialog extends Mixins(DialogButton) {
  @Prop({ default: "" }) buttonText!: string;
  @Prop({ default: "" }) tooltipText!: string;
  @Prop({ default: "" }) disabledTooltipText!: string;
  @Prop({ default: "" }) icon!: string;
  @Prop({ default: false }) disabled!: boolean;
  @Prop({ default: "75%" }) maxWidth!: string;
  @Prop({ default: false }) loading!: boolean;
}
